module.exports = __webpack_public_path__ + "src/assets/individualImages/worker.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/worker.png
// module id = ./src/assets/individualImages/worker.png
// module chunks = 0